import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'PickupOperator';

const PickupOperatorApi: any = baseApi(endpoint);

export default PickupOperatorApi;